// extracted by mini-css-extract-plugin
export default {"CreateProfileModal":"CreateProfileModal_CreateProfileModal__A-2Dz","CreateProfileContainer":"CreateProfileModal_CreateProfileContainer__ZGG19"};